import React, { useState, useEffect } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MainLayout from './MainLayout';
import { MobileNavShell } from './mobileNav';
import { useAuth } from '../../context/AuthContext';
import { useNotifications } from '../../context/NotificationContext';
import api from '../../utils/api';

const fetchUserProfile = async () => {
  try {
    const [userResponse, weddingResponse] = await Promise.all([
      api.get('/api/auth/me'),
      api.get('/api/wedding'),
    ]);
    return {
      ...userResponse.data,
      wedding: weddingResponse.data,
    };
  } catch (error) {
    throw error;
  }
};

/**
 * Responsive layout component that switches between desktop and mobile layouts
 * Desktop: Fixed 200px drawer on the left, content area takes remaining space
 * Mobile: Top bar, bottom nav, menu drawer (new design)
 */
function ResponsiveLayout({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const { user } = useAuth();
  const {
    notifications,
    unreadCount,
    markAsRead,
    markAllAsRead,
    deleteAllNotifications,
    deleteNotification,
  } = useNotifications();
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    if (isMobile) {
      fetchUserProfile()
        .then(setUserProfile)
        .catch(() => {
          if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
            navigate('/login');
          }
        });
    }
  }, [isMobile, navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const profileData = userProfile
    ? {
        firstName: userProfile.firstName,
        lastName: userProfile.lastName,
        email: userProfile.email,
        profilePicture: userProfile.profilePicture,
        name: userProfile.firstName || user?.name,
      }
    : user
      ? {
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          profilePicture: user.profilePicture,
          name: user.firstName || user.name,
        }
      : null;

  return isMobile ? (
    <MobileNavShell
      isSupplier={false}
      userProfile={profileData}
      notifications={notifications}
      unreadCount={unreadCount}
      onMarkAsRead={markAsRead}
      onMarkAllAsRead={markAllAsRead}
      onDeleteAllNotifications={deleteAllNotifications}
      onDeleteNotification={deleteNotification}
      onNotificationPageClick={() => navigate('/notifications')}
      onLogout={handleLogout}
    >
      <Box sx={{ p: 2 }}>{children}</Box>
    </MobileNavShell>
  ) : (
    <MainLayout>{children}</MainLayout>
  );
}

export default ResponsiveLayout; 